// Configuración de AWS para subida de imágenes a S3
import { resolveApiUrl } from './apiUrl';

export const AWS_CONFIG = {
  API_URL: resolveApiUrl(),
};
